import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_TRUSTED_PARTY_INVALID_ENTITLEMENT_TITLE,
	ONBOARDING_ERROR_TRUSTED_PARTY_INVALID_ENTITLEMENT_DESCRIPTION,
} from '../../../../constants/Copy';
import { useParams } from 'react-router';

const DefaultTrustedPartyInvalid = () => {
	const { partnerName } = useParams();

	return (
		<FullPageMessage
			title={ONBOARDING_ERROR_TRUSTED_PARTY_INVALID_ENTITLEMENT_TITLE}
			description={ONBOARDING_ERROR_TRUSTED_PARTY_INVALID_ENTITLEMENT_DESCRIPTION.replaceAll(
				'{trustedParty}',
				partnerName
			)}
		/>
	);
};

DefaultTrustedPartyInvalid.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultTrustedPartyInvalid;
